export const ACCESS_DENIED = 'Page Not Found';